import React, { Component } from "react";
import { connect } from "react-redux";

import { PROFESSOR_REQUESTED } from "../actions.js";
import ProfCardContainer from "./profecomments/ProfCardContainer.js";
import NewCommentContainer from "./profecomments/NewCommentContainer.js";
import CommentsColumnContainer from "./profecomments/CommentsColumnContainer.js";

import "../assets/css/ProfessorPane.css";

// TODO: Set global loading for state.data.
// TODO: Use localized loading for Search and Profe pages.
class ProfeComments extends Component {
  componentDidMount() {
    this.props.onProfessorSelect(this.props.match.params.professorId);
  }
  render() {
    if (
      this.props.professor === null ||
      this.props.professorVotes === null ||
      this.props.commentVotes === null
    ) {
      return null;
    }

    return (
      <div className="row">
        <div className="col-md-6">
          <ProfCardContainer />
          <NewCommentContainer />
        </div>
        <div className="col-md-6">
          <CommentsColumnContainer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => {
  return {
    onProfessorSelect: professorId => {
      dispatch({ type: PROFESSOR_REQUESTED, id: professorId });
    }
  };
};

const ProfeCommentsContainer = connect(mapStateToProps, mapDispatchToProps)(
  ProfeComments
);

export default ProfeCommentsContainer;



// WEBPACK FOOTER //
// ./src/containers/ProfeCommentsContainer.js